module.exports = __webpack_public_path__ + "img/yi_caina@2x.3be634ea.png";